import PropTypes from 'prop-types';
import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import React from 'react';
import pricingData from '../../../data/pricing-cards.json';

function Header({ serviceType = 'cleaning' }) {
  const serviceData = pricingData.services[serviceType];

  useLayoutEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo('.header', { y: 200 }, { y: 0 }, '+=2.5');
    tl.fromTo(
      '.header .container',
      { opacity: 0, translateY: 40 },
      { opacity: 1, translateY: 0 },
      '-=0'
    );

    // Cleanup function
    return () => tl.kill();
  }, []);

  if (!serviceData) {
    console.error(`No service data found for service type: ${serviceType}`);
    return null;
  }

  return (
    <div
      className="header page-header bg-img section-padding"
      data-background="/dark/assets/imgs/header/b5.jpg"
      data-overlay-dark="9"
    >
      <div className="container pt-100">
        <div className="text-center">
          <h1>{serviceData.title}</h1>
          <div className="mt-15">
            <a href="/dark/home-main">Home</a>
            <span className="padding-rl-20">|</span>
            <a href="/dark/page-services">Services</a>
            <span className="padding-rl-20">|</span>
            <span className="main-color">{serviceData.title}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// Add propTypes for validation
Header.propTypes = {
  serviceType: PropTypes.string, // Expect serviceType to be a string
};

// Add defaultProps for defaults
Header.defaultProps = {
  serviceType: 'cleaning', // Default serviceType is 'cleaning'
};

export default Header;
